import { useCallback, useContext, useEffect } from 'react';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { socketSubscribe } from '@namespace/socket';
import { UserContext } from '@namespace/user';

interface TransactionStatus {
  transaction_id: number;
  type: 'DEPOSIT' | 'WITHDRAWAL';
  status: 'completed' | 'canceled';
  amount: string;
  currency: string;
}

export const useTransactionStatus = () => {
  const { errorNotification, successNotification } = useNotifications();
  const [, { INCREMENT_COUNT_OF_SUCCESSFUL_DEPOSITS }] =
    useContext(UserContext);

  const { t } = useI18n();

  const callback = useCallback(
    ({ data }: { data: TransactionStatus }) => {
      const { type, status } = data;
      if (type === 'DEPOSIT' && status === 'completed') {
        successNotification(t('web.toasters.deposit_credited'));
        INCREMENT_COUNT_OF_SUCCESSFUL_DEPOSITS();
      }

      if (type === 'DEPOSIT' && status === 'canceled') {
        errorNotification(t('web.toasters.deposit_rejected'));
      }

      if (type === 'WITHDRAWAL' && status === 'completed') {
        successNotification(t('web.toasters.withdrawal_released'));
      }

      if (type === 'WITHDRAWAL' && status === 'canceled') {
        errorNotification(t('web.toasters.withdrawal_rejected'));
      }
    },
    [errorNotification, successNotification, t]
  );

  useEffect(() => {
    socketSubscribe({
      name: 'transaction_updated',
      types: ['transaction_id'],
      callback
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
